import { Reveal } from "./Reveal";
import { scrollToId, scrollToForm } from "../config";

export const FinalCTA = () => (
  <section data-testid="final-cta" className="relative overflow-hidden border-t border-white/10 py-28 sm:py-36">
    <div
      className="pointer-events-none absolute left-1/2 top-1/2 h-[600px] w-[900px] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-20"
      style={{ background: "radial-gradient(closest-side, rgba(0,156,222,0.35), transparent)" }}
    />
    <div className="relative mx-auto max-w-4xl px-6 text-center">
      <Reveal>
        <h2 className="font-display text-4xl font-extrabold tracking-tighter sm:text-6xl">
          Know What You're Paying.
          <br />
          <span className="text-mint">Find Out What Could Change.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mx-auto mt-8 max-w-2xl text-white/60 sm:text-lg">
          You don't need another complicated project. You don't need to spend hours researching
          processing companies. And you don't need to keep paying more simply because switching
          sounds difficult. Let CardConnect do the work.
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <button
            data-testid="final-primary-cta"
            onClick={scrollToForm}
            className="rounded-full bg-mint px-10 py-5 font-display text-lg font-bold text-cream shadow-[0_0_60px_rgba(0,156,222,0.35)] transition-transform duration-300 hover:scale-105 hover:brightness-110"
          >
            REQUEST MY FREE SAVINGS REVIEW →
          </button>
          <button
            data-testid="final-secondary-cta"
            onClick={() => scrollToId("calculator")}
            className="rounded-full border border-white/20 px-10 py-5 font-display text-lg font-bold transition-colors duration-300 hover:border-mint hover:text-mint"
          >
            CALCULATE MY SAVINGS
          </button>
        </div>
        <p className="mt-6 font-mono text-xs text-white/40">
          No pressure. No obligation. Just find out what you could be saving.
        </p>
        <p className="mt-10 font-mono text-[10px] uppercase tracking-[0.35em] text-white/30">
          You have nothing to lose except higher processing fees
        </p>
      </Reveal>
    </div>
  </section>
);
